import { put, takeLatest } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { setContracts, setIsLoading, setError, setPagination, setPaginationCursors, setCurrentContract } from './DashboardV2Slice'

export const dashboardV2Actions = {
  LOAD_CONTRACTS: 'LOAD_CONTRACTS_V2',
  LOAD_CONTRACT_DETAILS: 'LOAD_CONTRACT_DETAILS_V2',
}

export function* loadContracts({ url }: any): Generator {
  try {
    yield put(setIsLoading(true))
    yield put(setError(null))

    if (!url) {
      yield put(setPagination({ currentPage: 1, prevCursor: null, nextCursor: null }))
      yield put(setIsLoading(false))
      return
    }

    const data: any = yield callApi({
      endpoint: url,
      method: 'GET',
      showErrorSnackbar: false,
    })

    yield put(setContracts((data.data as unknown as any[]) ?? []))
    yield put(
      setPaginationCursors({
        prevCursor: (data.prev_cursor as string) ?? null,
        nextCursor: (data.next_cursor as string) ?? null,
      }),
    )
  } catch (error) {
    yield put(setError((error as Error).message))
  } finally {
    yield put(setIsLoading(false))
  }
}

export function* loadContractDetails({ url, contactZohoId }: any): Generator {
  try {
    yield put(setCurrentContract(null))

    if (!url) return

    const data: any = yield callApi({
      endpoint: url,
      method: 'GET',
      showErrorSnackbar: false,
    })

    yield put(setCurrentContract({
      id: contactZohoId,
      comments: data?.contact?.comments ?? [],
    }))
  } catch {
    // Silent fail — detail loading is non-blocking
  }
}

export default function* dashboardV2Sagas() {
  yield takeLatest(dashboardV2Actions.LOAD_CONTRACTS, loadContracts)
  yield takeLatest(dashboardV2Actions.LOAD_CONTRACT_DETAILS, loadContractDetails)
}
